import { BadgeStatus } from './badge-status';

export const BadgesQuerySymbol = Symbol.for('BadgesQuery');

interface Badge {
  id: string;
  title: string;
  imageUri: string;
  descriptionFragment: string | '';
  earnedDescriptionFragment: string | '';
  status: BadgeStatus;
  date: Date | null;
}

export type RemoteStateQueryPhase = 'none' | 'loading' | 'loaded';
export type LoadingPhase = 'none' | 'loading' | 'loaded';

export interface BadgesQuery {
  badges: Badge[];
  loadingPhase: LoadingPhase;
  remotePhase: RemoteStateQueryPhase;
}

export type QueriedBadge = Badge;
